export const LineEmptyEmailError = "line_account_empty_email";
export const trackingAnonymousId = "anonymous_id"; // used for segment
export const trackingUserId = "user_id"; // used for segment
